import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/panxo/Development/LigasDeportivas/web/src/app/[locale]/NotFoundClient.tsx");
